import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c79cc288&scoped=true&"
import script from "./sms.js?vue&type=script&lang=js&"
export * from "./sms.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c79cc288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79cc288",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c79cc288')) {
      api.createRecord('c79cc288', component.options)
    } else {
      api.reload('c79cc288', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c79cc288&scoped=true&", function () {
      api.rerender('c79cc288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sms/index.vue"
export default component.exports